import React from "react";
import LogListItem from "../../components/log/LogList/LogListItem";
import {Box} from "@mui/material";
import {useParams} from "react-router";
import {useTitle} from 'react-use';
import { t } from "@lingui/core/macro";

const LogListPage = ()  => {

    useTitle(t`List Log`);
    
    const allQueries = useParams()
    const query = Object.fromEntries(
        Object.entries(allQueries).filter(([key]) => key.endsWith("Id"))
    )
    
    return (
        <Box>
            <LogListItem showAdd={true} {...query} />
        </Box>
    )
}

export default LogListPage;
